/** Assistant State */
export enum AssistantState {
  Busy = 'Busy',
  Idle = 'Idle'
}

/** System Message Type */
export enum AssistantSystemMessageType {
  Action = 'Action',
  Error = 'Error'
}

/** DataSourceSyncStatus enum */
export enum DataSourceSyncStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

/**
 * DocumentRelationshipType enum represents the types of relationships
 * that can exist between documents in a data source sync.
 */
export enum DocumentRelationshipType {
  /** Parent-child hierarchical relationship */
  Hierarchical = 'Hierarchical',
  /** Key-based mapping relationship (e.g., customer_id ↔ customerId) */
  KeyMapping = 'KeyMapping',
  /** Reference to a lookup table */
  Reference = 'Reference',
  /** Time-based relationship */
  Temporal = 'Temporal'
}

/** EquityActivationUnit defines whether equity activation is based on percentage or currency */
export enum EquityActivationUnit {
  Currency = 'Currency',
  Percentage = 'Percentage'
}

/** Financing Status */
export enum FinancingStatus {
  Active = 'Active',
  Terminated = 'Terminated'
}

/** Invitee Type */
export enum InviteeType {
  Expired = 'Expired',
  NewUser = 'NewUser'
}

/** Job Status Enum - represents the possible states of a job */
export enum JobStatus {
  Active = 'Active',
  Completed = 'Completed',
  Delayed = 'Delayed',
  Failed = 'Failed',
  Paused = 'Paused',
  Waiting = 'Waiting'
}

/** Lead Priority */
export enum LeadPriority {
  Critical = 'Critical',
  High = 'High',
  Medium = 'Medium',
  Monitor = 'Monitor'
}

/** Fields available for sorting leads */
export enum LeadSortingField {
  ActualTradeInValue = 'ActualTradeInValue',
  CustomerName = 'CustomerName',
  Priority = 'Priority',
  RemainingLoan = 'RemainingLoan',
  Score = 'Score',
  Status = 'Status',
  VehicleModel = 'VehicleModel'
}

/** Lead Status */
export enum LeadStatus {
  Assigned = 'Assigned',
  Contacted = 'Contacted',
  Converted = 'Converted',
  Discarded = 'Discarded',
  Eligible = 'Eligible',
  Ignored = 'Ignored',
  Ineligible = 'Ineligible',
  NotInterested = 'NotInterested',
  Rescheduled = 'Rescheduled'
}

/** OrganizationMarket defines the various markets an organization can operate in */
export enum OrganizationMarket {
  Global = 'Global',
  Singapore = 'Singapore'
}

/** Organization Membership Role */
export enum OrganizationMembershipRole {
  Administrator = 'Administrator',
  Member = 'Member',
  Owner = 'Owner'
}

/** Queue Event Type - types of events that can occur on queues */
export enum QueueEventType {
  JobAdded = 'JobAdded',
  JobCompleted = 'JobCompleted',
  JobFailed = 'JobFailed',
  JobRemoved = 'JobRemoved',
  JobRetried = 'JobRetried',
  JobStarted = 'JobStarted'
}

/** Score Category for Analysis */
export enum ScoreCategory {
  Financial = 'Financial',
  Loan = 'Loan',
  Vehicle = 'Vehicle'
}

/** Sort direction */
export enum SortingDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}
